import React from 'react';
import {
  createBrowserRouter,
  generatePath as generatePathRR,
} from 'react-router';
import type { Empty } from '@owl-frontend/components';
import { CombineObjectType, enumSet } from '@owl-lib/type-util';
import AppProvider from '../../context/AppProvider';
import type { GeneratePathParam } from '../../helpers/route-types';
import EscContainer from '../Container';
import EscDossierLayout from '../DossierLayout';
import ErrorContainer from '../ErrorContainer/ErrorContainer';
import EscHomeContainer from '../HomeContainer';
import DefaultRedirect from './DefaultRedirect';

export enum EscRouteDefs {
  Root = '/',
  Home = '/home',
  Broken = '/uh-oh',
  Dossier = '/claims/:dossierId',
}

export const routeSet = enumSet(EscRouteDefs);

type GeneratePathRest<Params> = Empty extends Params
  ? [params?: Params]
  : [params: Params];
type TypedGeneratePath = <R extends string>(
  path: R,
  ...rest: GeneratePathRest<CombineObjectType<GeneratePathParam<R>>>
) => string;
export const generatePath = generatePathRR as TypedGeneratePath;

const router = createBrowserRouter([
  {
    path: EscRouteDefs.Root,
    Component: AppProvider,
    ErrorBoundary: ErrorContainer,
    children: [
      {
        path: EscRouteDefs.Broken,
        element: <ErrorContainer />,
      },
      {
        path: EscRouteDefs.Root,
        element: <EscContainer />,
        children: [
          {
            index: true,
            element: <DefaultRedirect path={EscRouteDefs.Home} />,
          },
          {
            path: EscRouteDefs.Home,
            element: <EscHomeContainer />,
          },
          {
            path: EscRouteDefs.Dossier,
            element: <EscDossierLayout />,
          },
          {
            path: '*',
            element: <DefaultRedirect path={EscRouteDefs.Home} />,
          },
        ],
      },
    ],
  },
]);

export default router;
